export default __webpack_public_path__ + "static/media/DSC_0263@2x.bad532cd.png";